<div class="cads-key-value-list">
  <div class="cads-key-value-list__grid">
    @for (row of config().rows; track $index) {
      @if (row.label) {
        <span class="cads-key-value-list__label">{{ row.label }}</span>
      }
      <span
        class="cads-key-value-list__value"
        [class.cads-key-value-list__value--full]="!row.label"
        [class.cads-key-value-list__value--primary]="!!row.label"
        >{{ row.value }}</span
      >
      @if (_showDividerAfter($index)) {
        <hr class="cads-key-value-list__divider" />
      }
    }
  </div>
</div>
